import { Auth } from 'aws-amplify';

export function loginEmailAPI(email, password) {
  return Auth.signIn(email, password);
}
